import React, { useEffect, useState } from "react";
import { generalIcons } from "../../utils/constants";
import { formatNumber } from "../../utils/helper";
import { getTrackBackground, Range } from "react-range";

export default function RewardCalculator({ calculatorApy, vanryPrice }) {
  const [validatorCommission, setValidatorCommission] = useState(25);
  const [stakingDuration, setStakingDuration] = useState(250);
  const [inputAmount, setInputAmount] = useState("");

  const [userRewards, setUserRewards] = useState({
    per_day: 0,
    per_week: 0,
    per_month: 0,
    per_year: 0,
    user_reward_per_days_selected: 0,
    user_reward_per_year: 0,
  });

  const handleInputChange = (e) => {
    let input = e.target.value;
    input = input.replace(/[^0-9]/g, "").replace(/(\..*)\./g, "$1");
    if (input.charAt(0) === "0") {
      setInputAmount("");
    } else {
      setInputAmount(input);
    }
  };

  const handleRewardCalculation = () => {
    const inputValue = Number(inputAmount);
    const rewardPerYearWithCommission = inputValue * calculatorApy;
    const currentValidatorCommission = Array.isArray(validatorCommission) ? validatorCommission[0] : validatorCommission
    const userRewardPerYear =
      rewardPerYearWithCommission * (1 - currentValidatorCommission / 100);
    const rewardPerDay = userRewardPerYear / 365;
    const rewardPerWeek = rewardPerDay * 7;
    const rewardPerMonth = rewardPerDay * 30;
    const rewardPerYear = rewardPerDay * 365;
    const rewardsPerDaysSelected = rewardPerDay * stakingDuration;
    const obj = {
      per_day: rewardPerDay,
      per_week: rewardPerWeek,
      per_month: rewardPerMonth,
      per_year: rewardPerYear,
      user_reward_per_days_selected: rewardsPerDaysSelected,
      user_reward_per_year: userRewardPerYear,
    };
    setUserRewards(obj);
  };

  const handleSliderMouseDown = (e, setValue, currentValue, maxValue) => {
    e.preventDefault(); // Prevent default behavior

    // Ensure the slider is correctly selected
    const slider = e.target
      .closest(".relative")
      ?.querySelector('input[type="range"]'); // Use optional chaining to avoid errors if `closest` fails

    if (!slider) {
      console.error("Slider element not found. Ensure the DOM structure is correct.");
      return; // Exit early if the slider is not found
    }

    // Calculate the initial value based on mouse position
    const updateSlider = (moveEvent) => {
      const sliderRect = slider.getBoundingClientRect(); // Get the slider's dimensions
      const newValue = Math.min(
        Math.max(
          ((moveEvent.clientX - sliderRect.left) / sliderRect.width) * maxValue,
          0
        ),
        maxValue
      );

      setValue(Math.round(newValue)); // Update the slider value
      slider.value = newValue; // Update the slider value visually
    };

    // Add event listeners to document for dragging
    document.addEventListener("mousemove", updateSlider);

    document.addEventListener("mouseup", () => {
      document.removeEventListener("mousemove", updateSlider); // Remove listeners on mouse up
    });
  };


  useEffect(() => {
    handleRewardCalculation();
  }, [inputAmount, validatorCommission, stakingDuration]);

  return (
    <div className="relative mt-10 lg:mt-[60px]">
      <h2 className="text-[30px] md:text-2xl lg:text-[64px] text-textcolor font-bold lg:-tracking-37 leading-none md:leading-[64px] mb-3 text-center laptop:text-left">
        Rewards Calculator
      </h2>

      <div className="mt-10 lg:mt-[58px] rounded-3xl w-full h-auto p-3 lg:p-[18px] border-[1.5px] border-[#1A1A1A]">
        <div className="grid laptop:grid-cols-2 gap-10">
          <div className="col-span-1">
            <div className="lg:p-7">
              <div className="flex items-center gap-2 lg:gap-4">
                <div className="w-10 h-10 lg:w-[54px] lg:h-[54px] flex items-center justify-center rounded-xl bg-[#010101] border-[1px] border-[#D9D9D9]/[.06] p-2 lg:p-3 text-green">
                  {generalIcons.calculator}
                </div>
                <h3 className="text-lg md:text-xl lg:text-[26px] lg:leading-7 font-medium -tracking-12 text-textcolor">
                  Vanar Rewards Calculator
                </h3>
              </div>

              <div className="mt-5 lg:mt-10 space-y-6 md:space-y-10 laptop:space-y-[50px]">
                <div className="text-white/65">
                  <div className="relative capitalize pl-5 lg:pl-8 text-xsm lg:text-sm before:absolute before:left-2 lg:before:left-4 before:top-1/2 before:-translate-y-1/2 before:w-[5px] before:h-[5px] before:bg-white/65 before:rounded-full">
                    Amount
                  </div>
                  <input
                    type="text"
                    name="amount"
                    placeholder="0"
                    autoComplete="off"
                    value={
                      inputAmount?.length > 0
                        ? Number(inputAmount).toLocaleString("en-US")
                        : inputAmount
                    }
                    onChange={handleInputChange}
                    className="border border-white/[.04] !bg-[#1A1A1A] rounded-2xl text-sm lg:text-xl leading-normal font-medium -tracking-07 text-white p-4 md:p-5 laptop:p-[30px] w-full focus:outline-none mt-3 lg:mt-5"
                  />
                </div>

                <div className="flex flex-col space-y-8">
                  {/* Validator Commission Slider */}
                  <div className="text-white/65">
                    <div className="relative capitalize pl-5 lg:pl-8 text-xsm lg:text-sm before:absolute before:left-2 lg:before:left-4 before:top-1/2 before:-translate-y-1/2 before:w-[5px] before:h-[5px] before:bg-white/65 before:rounded-full">
                      Validator Commission
                    </div>
                    {/* <div className="relative mt-12 lg:mt-16">
                      <div className="relative w-full h-5 lg:h-[26px]">
                        <input
                          type="range"
                          min="0"
                          max="100"
                          value={validatorCommission}
                          onChange={(e) =>
                            setValidatorCommission(e.target.value)
                          }
                          className="slider appearance-none w-full h-full bg-[#1A1A1A] focus:bg-[#1A1A1A] outline-none rounded-sm cursor-pointer overflow-hidden"
                        />
                        <div
                          className="absolute -top-9 lg:-top-10 -translate-x-1/2 text-[#A08CFF] text-xs lg:text-sm font-normal whitespace-nowrap ml-[2px] laptop:ml-[6px]"
                          style={{ left: `${validatorCommission}%` }}
                        >
                          <span className="relative bottom-[6px]">
                            {validatorCommission}%
                          </span>
                          <div
                            onMouseDown={(e) => {
                              handleSliderMouseDown(
                                e,
                                setValidatorCommission,
                                validatorCommission,
                                100
                              );
                            }}
                          >
                            {generalIcons.rangeArrow}
                          </div>
                        </div>
                      </div>
                    </div> */}
                                        <div className="relative !mt-[50px] lg:!mt-16">
                      <Range
                        label="Select your value"
                        step={1}
                        min={0}
                        max={100}
                        values={[validatorCommission]}
                        onChange={(value) => setValidatorCommission(value)}
                        renderTrack={({ props, children }) => (
                          <div
                            onMouseDown={props.onMouseDown}
                            onTouchStart={props.onTouchStart}
                            style={{
                              ...props.style,
                              height: '36px',
                              display: 'flex',
                              width: '100%',
                            }}
                          >
                            <div
                              ref={props.ref}
                              style={{
                                height: '26px',
                                width: '100%',
                                background: getTrackBackground({
                                  values: [validatorCommission],
                                  colors: ['#a08cff', '#1a1a1a'],
                                  min: 0,
                                  max: 100,
                                }),
                                alignSelf: 'center',
                              }}
                            >
                              {children}
                            </div>
                          </div>
                        )}
                        renderThumb={({ props }) => (
                          <div
                            {...props}
                            key={props.key}
                          />
                        )}
                      />
                      <div
                        className="absolute -top-9 lg:-top-10 -translate-x-1/2 flex flex-col items-center text-[#A08CFF] text-xs lg:text-sm font-normal whitespace-nowrap ml-[2px] laptop:ml-[1.5px] capitalize"
                        style={{
                          left: `${(validatorCommission / 100) * 99.5}%`,
                        }}
                        onMouseDown={(e) => {
                          handleSliderMouseDown(
                            e,
                            setValidatorCommission,
                            validatorCommission,
                            100
                          );
                        }}
                      >
                        <span className="relative bottom-[6px]">
                          {validatorCommission}%
                        </span>
                        <div

                        >
                          {generalIcons.rangeArrow}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Staking Duration Slider */}
                  <div className="text-white/65">
                    <div className="relative capitalize pl-5 lg:pl-8 text-xsm lg:text-sm before:absolute before:left-2 lg:before:left-4 before:top-1/2 before:-translate-y-1/2 before:w-[5px] before:h-[5px] before:bg-white/65 before:rounded-full">
                      Staking Duration
                    </div>
                    {/* <div className="relative mt-12 lg:mt-16">
                      <div className="relative w-full h-5 lg:h-[26px]">
                        <input
                          type="range"
                          min="0"
                          max="365"
                          value={stakingDuration}
                          onChange={(e) => setStakingDuration(e.target.value)}
                          className="slider appearance-none w-full h-full bg-[#1A1A1A] focus:bg-[#1A1A1A] outline-none rounded-sm cursor-pointer overflow-hidden"
                        />
                        <div
                          className="absolute -top-12 lg:-top-10 -translate-x-1/2 flex flex-col items-center text-[#A08CFF] text-xs lg:text-sm font-normal whitespace-nowrap ml-[2px] laptop:ml-[1.5px] capitalize"
                          style={{
                            left: `${(stakingDuration / 365) * 99.5}%`,
                          }}
                        >
                          <span className="relative bottom-[6px]">
                            {stakingDuration} days
                          </span>
                          <div
                            onMouseDown={(e) => {
                              handleSliderMouseDown(
                                e,
                                setStakingDuration,
                                stakingDuration,
                                365
                              );
                            }}
                          >
                            {generalIcons.rangeArrow}
                          </div>
                        </div>
                      </div>
                    </div> */}

                  </div>
                </div>
                <div className="relative !mt-[50px] lg:!mt-16">
                  <Range
                    label="Select your value"
                    step={1}
                    min={0}
                    max={365}
                    values={[stakingDuration]}
                    onChange={(value) => setStakingDuration(value)}
                    renderTrack={({ props, children }) => (
                      <div
                        onMouseDown={props.onMouseDown}
                        onTouchStart={props.onTouchStart}
                        style={{
                          ...props.style,
                          height: '36px',
                          display: 'flex',
                          width: '100%',
                        }}
                      >
                        <div
                          ref={props.ref}
                          style={{
                            height: '26px',
                            width: '100%',
                            background: getTrackBackground({
                              values: [stakingDuration],
                              colors: ['#a08cff', '#1a1a1a'],
                              min: 0,
                              max: 365,
                            }),
                            alignSelf: 'center',
                          }}
                        >
                          {children}
                        </div>
                      </div>
                    )}
                    renderThumb={({ props }) => (
                      <div
                        {...props}
                        key={props.key}
                      />
                    )}
                  />
                  <div
                    className="absolute -top-9 lg:-top-10 -translate-x-1/2 flex flex-col items-center text-[#A08CFF] text-xs lg:text-sm font-normal whitespace-nowrap ml-[2px] laptop:ml-[1.5px] capitalize"
                    style={{
                      left: `${(stakingDuration / 365) * 99.5}%`,
                    }}
                    onMouseDown={(e) => {
                      handleSliderMouseDown(
                        e,
                        setStakingDuration,
                        stakingDuration,
                        365
                      );
                    }}
                  >
                    <span className="relative bottom-[6px]">
                      {stakingDuration} days
                    </span>
                    <div

                    >
                      {generalIcons.rangeArrow}
                    </div>
                  </div>
                </div>
                {/* <div style={{touchAction:"manipulation"}}>
                <RangeSlider max={365} value={}/>
                </div> */}
              </div>
            </div>
          </div>
          <div className="col-span-1">
            <div className="bg-[#121212] rounded-[18px] p-4 lg:p-8">
              <div className="flex items-center gap-2 lg:gap-4">
                <div className="w-10 h-10 lg:w-[54px] lg:h-[54px] flex items-center justify-center rounded-xl bg-[#010101] border-[1px] border-white/[.04] p-2 lg:p-3 text-green">
                  {generalIcons.reward}
                </div>
                <h3 className="text-lg md:text-xl lg:text-[26px] lg:leading-7 font-medium -tracking-12 text-textcolor">
                  Total Rewards Earned
                </h3>
              </div>

              <div className="relative mt-10 laptop:mt-20">
                <div className="relative flex items-end gap-[10px]">
                  <h2 className="text-[26px] md:text-[40px] lg:text-[58px] text-textcolor font-semibold leading-none -tracking-21 lg:-tracking-37">
                    {formatNumber(
                      userRewards?.user_reward_per_days_selected
                    )}{" "}
                    $VANRY
                  </h2>

                  <span className="relative laptop:bottom-2 p-1 laptop:p-2 rounded-md bg-green/10 text-green text-xs laptop:text-[17px] leading-none font-normal capitalize">
                    $
                    {formatNumber(
                      (
                        userRewards?.user_reward_per_days_selected *
                        vanryPrice
                      )
                    )}
                  </span>
                </div>

                <ul className="mt-9 flex flex-col gap-3 lg:gap-4">
                  <li className="flex items-center justify-between gap-3 lg:gap-5 bg-[#1A1A1A] rounded-xl lg:rounded-2xl p-4 lg:px-6 lg:py-4">
                    <div className="text-xsm lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim whitespace-nowrap">
                      <span className="text-dim/50">1 day</span> -{" "}
                      {inputAmount
                        ? formatNumber(
                          (
                            (userRewards?.per_day / Number(inputAmount)) *
                            100
                          )
                        )
                        : 0}
                      %
                    </div>

                    <div className="flex justify-end items-center flex-wrap sm:flex-nowrap gap-2 lg:gap-3">
                      <div className="text-[15px] lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim">
                        {formatNumber(userRewards?.per_day) ?? 0}{" "}
                        $vanry
                      </div>
                      <span className="p-1 laptop:px-[10px] laptop:py-2 rounded-lg bg-green/10 text-green text-xs laptop:text-base leading-none font-normal capitalize">
                        $
                        {formatNumber(
                          (userRewards?.per_day * vanryPrice)
                        ) ?? 0}
                      </span>
                    </div>
                  </li>

                  <li className="flex items-center justify-between gap-3 lg:gap-5 bg-[#1A1A1A] rounded-xl lg:rounded-2xl p-4 lg:px-6 lg:py-4">
                    <div className="text-xsm lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim whitespace-nowrap">
                      <span className="text-dim/50">1 week</span> -{" "}
                      {inputAmount
                        ? formatNumber(
                          (
                            (userRewards?.per_week / Number(inputAmount)) *
                            100
                          )
                        )
                        : 0}
                      %
                    </div>

                    <div className="flex justify-end items-center flex-wrap sm:flex-nowrap gap-2 lg:gap-3">
                      <div className="text-[15px] lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim">
                        {formatNumber(userRewards?.per_week) ?? 0}{" "}
                        $vanry
                      </div>
                      <span className="p-1 laptop:px-[10px] laptop:py-2 rounded-lg bg-green/10 text-green text-xs laptop:text-base leading-none font-normal capitalize">
                        $
                        {formatNumber(
                          (userRewards?.per_week * vanryPrice)
                        ) ?? 0}
                      </span>
                    </div>
                  </li>

                  <li className="flex items-center justify-between gap-3 lg:gap-5 bg-[#1A1A1A] rounded-xl lg:rounded-2xl p-4 lg:px-6 lg:py-4">
                    <div className="text-xsm lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim whitespace-nowrap">
                      <span className="text-dim/50">1 month</span> -{" "}
                      {inputAmount
                        ? formatNumber(
                          (
                            (userRewards?.per_month / Number(inputAmount)) *
                            100
                          )
                        )
                        : 0}
                      %
                    </div>

                    <div className="flex justify-end items-center flex-wrap sm:flex-nowrap gap-2 lg:gap-3">
                      <div className="text-[15px] lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim">
                        {formatNumber(userRewards?.per_month) ?? 0}{" "}
                        $vanry
                      </div>
                      <span className="p-1 laptop:px-[10px] laptop:py-2 rounded-lg bg-green/10 text-green text-xs laptop:text-base leading-none font-normal capitalize">
                        $
                        {formatNumber(
                          (userRewards?.per_month * vanryPrice)
                        ) ?? 0}
                      </span>
                    </div>
                  </li>

                  <li className="flex items-center justify-between gap-3 lg:gap-5 bg-[#1A1A1A] rounded-xl lg:rounded-2xl p-4 lg:px-6 lg:py-4">
                    <div className="text-xsm lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim whitespace-nowrap">
                      {/* <span className="text-dim/50">1 year</span> - 5% */}
                      <span className="text-dim/50">1 year</span> -{" "}
                      {inputAmount
                        ? formatNumber(
                          (
                            (userRewards?.per_year / Number(inputAmount)) *
                            100
                          )
                        )
                        : 0}
                      %
                    </div>

                    <div className="flex justify-end items-center flex-wrap sm:flex-nowrap gap-2 lg:gap-3">
                      <div className="text-[15px] lg:text-[17px] font-normal leading-none uppercase -tracking-03 text-dim">
                        {formatNumber(userRewards?.per_year) ?? 0}{" "}
                        $vanry
                      </div>
                      <span className="p-1 laptop:px-[10px] laptop:py-2 rounded-lg bg-green/10 text-green text-xs laptop:text-base leading-none font-normal capitalize">
                        $
                        {formatNumber(
                          (userRewards?.per_year * vanryPrice)
                        )}
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
